import styled from 'styled-components'

import { Link } from 'gatsby'
import { Colors, FontRegular } from './../../utils/variables'

export const List = styled.ul`
    a, span {
        color: ${props => (props.theme === 'light') ? `${Colors.white}` : `${Colors.blue}`};
    }

    polygon {
        fill: ${props => (props.theme === 'light') ? `${Colors.white}` : `${Colors.blue}`};
    }

    ${props => props.homeTop && `
        ul {
            background-color: transparent;
        }
    `}

    ${props => props.isTop ? `
        ul {
            padding: 4px 0;
        } 
    ` : `
        ul {
            padding: 32px 0 0 0;

            &:before {
                content: '';
                position: absolute;
                
                top: 32px;
                left: 0;

                width: 1px;
                height: calc(100% - 32px);
                
                background-color: rgba(0, 0, 0, 0.1);
            }

            &:after {
                content: '';
                position: absolute;
                
                top: 32px;
                right: 0;

                width: 1px;
                height: calc(100% - 32px);
                
                background-color: rgba(0, 0, 0, 0.1);
            }

            li {
                &:first-of-type {
                    border-top: 1px solid rgba(0, 0, 0, 0.1);
                }
            }
        }
    `}
`

export const Item = styled.li`
    position: relative;

    padding: 0 15px;

    white-space: nowrap;

    &:hover {
        > ul {
            display: block;
        }
    }
`

export const StyledLink = styled(Link).attrs({activeClassName: 'active'})`
    position: relative;

    ${FontRegular}
    font-size: 13px;
    line-height: 1em;
    letter-spacing: 1px;

    opacity: 0.5;

    text-transform: uppercase;
    text-decoration: none;

    transition: opacity 0.15s ease-out;

    &:before {
        content: '';
        position: absolute;

        bottom: -5px;
        left: 50%;

        transform: translateX(-50%);

        width: 0;
        height: 1px;

        opacity: 0;

        background-color: ${props => (props.theme === 'light') ? `${Colors.white}` : `${Colors.blue}`};

        transition: all 0.15s ease-out;
    }

    &:hover {
        opacity: 0.5;

        + img {
            opacity: 1;
        }
    }

    &:not(.active) {
        &:hover {
            opacity: 1;

            + img {
                opacity: 1;
            }

            &:before {
                opacity: 1;

                width: 100%;
            }
        }
    }

    &.active {
        opacity: 1;

        + img {
            opacity: 1;
        }

        &:before {
            opacity: 1;

            width: 100%;
        }

        &:hover {
            opacity: 1;
        }

        &:active {
            &:before {
                width: 70%;
            }
        }
    }
`

export const NoPageLink = styled.span`
    position: relative;

    ${FontRegular}
    font-size: 13px;
    line-height: 1em;
    letter-spacing: 1px;

    opacity: 0.5;
    cursor: default;

    text-transform: uppercase;
    text-decoration: none;

    transition: opacity 0.15s ease-out;

    &:hover {
        opacity: 0.5;

        + img {
            opacity: 1;
        }
    }

    &:not(.active) {
        &:hover {
            opacity: 1;

            + img {
                opacity: 1;
            }
        }
    }

    &.active {
        opacity: 1;

        + img {
            opacity: 1;
        }

        &:hover {
            opacity: 1;
        }
    }
`

export const Icon = styled.svg`
    display: inline-block;

    width: 6px;
    height: 6px;

    margin-left: 5px;

    opacity: 0.5;

    transition: all 0.15s ease-out;
`

export const SubList = styled.ul`
    position: absolute;
    left: 0;

    overflow: hidden;
    white-space: nowrap;
    
    display: none;
    
    width: auto;
    
    background-color: ${Colors.white};
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
`

export const SubItem = styled.li`
    display: block;

    padding: 15px;

    &:first-of-type {
        padding-bottom: 5px;
    }
`

export const SubLink = styled(Link)`
    display: block;

    ${FontRegular}
    font-size: 13px;
    line-height: 1em;
    // letter-spacing: 1px;

    text-decoration: none;
    // text-transform: uppercase;

    opacity: 0.5;

    color: ${Colors.blue};

    transition: opacity 0.15s ease-out;

    &:hover {
        opacity: 0.5;

        + img {
            opacity: 1;
        }
    }

    &:not(.active) {
        &:hover {
            opacity: 1;

            + img {
                opacity: 1;
            }
        }
    }

    &.active {
        opacity: 1;

        + img {
            opacity: 1;
        }

        &:hover {
            opacity: 1;
        }
    }
`